<template>

    <MenuSiModuleAffiliate/>
    <MenuSiConfigurationAffiliate/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>User Settings</h3>

                    <div class="field">
                        <label for="username">Username</label>
                        <InputText id="username" type="text" :disabled="true" v-model.trim="profile.username"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" type="text" :disabled="true" v-model.trim="profile.email"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="mobile" type="text" :disabled="true" v-model.trim="profile.mobile"/>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiModuleAffiliate from "@/components/menu/simodule/MenuSiModuleAffiliate.vue";
import MenuSiConfigurationAffiliate from "@/components/menu/simodule/MenuSiConfigurationAffiliate.vue";

export default {
    components: {
        MenuSiModuleAffiliate,
        MenuSiConfigurationAffiliate,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return; // Exit early if getUser fails
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);

            if ((this.profile.rights === 'C') || (this.profile.rights === 'A')) {
                this.courseRights = "Yes"
            } else {
                this.courseRights = "No"
            }
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
        }

        // try {
        //     const [companyConfigData] = await Promise.all([
        //         CompanyService.getCompanyConfiguration(this.profile.companyId)
        //     ]);
        //
        //     this.companyConfiguration = companyConfigData.data;
        //     console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);
        //
        // } catch (e) {
        //     console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
        // }

        console.log("[Configuration][mounted] this.userConfiguration = ", this.userConfiguration);
        // console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
    },
    data() {

        return {
            profile: {},
            userConfiguration: {},
            companyConfiguration: {},
            courseRights: "No",
            confirmations: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Other', code: 'O'}
            ],
        }
    },
    methods: {
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
